// import React, { useState, useEffect } from 'react';
// import './Hero.css';

// // Keep your existing image imports
// import s1 from '../Images/s1.jpg';
// import s2 from '../Images/s2.jpg'; 
// import s3 from '../Images/s3.jpg';
// import s4 from '../Images/s4.jpg';
// import s5 from '../Images/s5.jpg';
// import s6 from '../Images/s6.jpg';
// import s8 from '../Images/s8.jpeg';
// import s9 from '../Images/s9.jpg';
// import s10 from '../Images/s10.jpeg';
// import s11 from '../Images/s11.jpg';
// import s12 from '../Images/s12.jpeg';


// const SLIDES = [
//   {
//     id: 1,
//     image: s11, 
//     title: "Realty Simplified",
//     subtitle: "Your Trusted Partner in Realty & Financial Advisory"
//   },
//   {
//     id: 2,
//     image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=2000&q=90",
//     title: "Build Generational Wealth",
//     subtitle: "Premium Residential, Commercial & Agricultural Properties"
//   },
//   { 
//     id: 3, 
//     image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=90",
//     title: "Luxury Living",
//     subtitle: "Experience grandeur in our high-rise apartments."
//   },
//   {
//     id: 4, 
//     image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2000&q=90",
//     title: "Commercial Excellence", 
//     subtitle: "Strategic locations for your business growth."
//   },
//   { 
//     id: 5, 
//     image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=2000&q=90",
//     title: "Agricultural Assets", 
//     subtitle: "Invest in nature with secure farmlands."
//   },
//   { 
//     id: 6, 
//     image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=2000&q=90",
//     title: "Industrial Solutions", 
//     subtitle: "Modern warehouses and factories."
//   },
//   { 
//     id: 7, 
//     image: "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?auto=format&fit=crop&w=2000&q=90",
//     title: "Serene Plantations", 
//     subtitle: "Sustainable timber and sandalwood investments."
//   },
//   { 
//     id: 8, 
//     image: "https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=2000&q=90",
//     title: "Holiday Retreats", 
//     subtitle: "Exclusive resorts and weekend getaways."
//   },
//   { 
//     id: 9, 
//     image: s9,
//     title: "Premium Open Plots", 
//     subtitle: "Ready-to-construct layouts in prime locations."
//   },
//   {
//     id: 10, 
//     image: s12,
//     title: "Hyderabad's Next Growth Corridor", 
//     subtitle: "Invest in strategic locations along the Regional Ring Road."
//   },
// ];

// const Hero = () => {
//   const [current, setCurrent] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrent((prev) => (prev + 1) % SLIDES.length);
//     }, 5000); 
//     return () => clearInterval(timer);
//   }, []);

//   // Helper to format numbers (e.g., 1 -> 01)
//   const formatNumber = (num) => (num < 10 ? `0${num}` : num);

//   return (
//     <section className="hero" id="home">
//       {/* 1. Background Image Layer */}
//       {SLIDES.map((slide, index) => (
//         <div 
//           key={slide.id}
//           className={`hero-slide ${index === current ? 'active' : ''}`}
//           style={{ backgroundImage: `url(${slide.image})` }}
//         >
//           {/* Darken overlay specifically for image readability */}
//           <div style={{ position: 'absolute', inset: 0, bg: 'rgba(0,0,0,0.2)' }}></div>
//         </div>
//       ))}
      
//       {/* 2. Global Overlay (Gradient) */}
//       <div className="hero-overlay"></div>
      
//       {/* 3. Text Content - Uses key={current} to trigger animation restart */}
//       <div className="hero-content" key={current}>
//         {/* The "Mask" creates the effect of text sliding up from nothing */}
//         <span className="text-mask">
//           <h1 className="hero-title">{SLIDES[current].title}</h1>
//         </span>
        
//         <p className="hero-subtitle">
//           {SLIDES[current].subtitle}
//         </p>
        
//         <a href="#contact" className="btn-premium">
//           Discover More
//         </a>
//       </div>

//       {/* 4. Premium Progress Bar Navigation */}
//       <div className="progress-container">
//         <div className="slide-counter">
//           {formatNumber(current + 1)} / {formatNumber(SLIDES.length)}
//         </div>
//         <div className="progress-track">
//           {/* Key={current} forces the progress bar to reset animation on slide change */}
//           <div className="progress-bar" key={current}></div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Hero;


import React, { useState, useEffect } from 'react';
import './Hero.css';

const API_URL = 'https://api.propertygalleria.in/api/sliders';

const Hero = () => {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);

  // Fetch slides from API
  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const res = await fetch(API_URL);
        const data = await res.json();
        setSlides(data || []);
      } catch (error) {
        console.error('Failed to fetch sliders:', error);
      }
    };

    fetchSlides();
  }, []);

  // Auto slide effect
  useEffect(() => {
    if (!slides.length) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides]);

  const formatNumber = (num) => (num < 10 ? `0${num}` : num);

  // Prevent render before data loads
  if (!slides.length) {
    return null; // or loader
  }

  return (
    <section className="hero" id="home">
      
      {/* 1. Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`hero-slide ${index === current ? 'active' : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(0,0,0,0.25)',
            }}
          />
        </div>
      ))}

      {/* 2. Gradient Overlay */}
      <div className="hero-overlay"></div>

      {/* 3. Text Content */}
      <div className="hero-content" key={current}>
        <span className="text-mask">
          <h1 className="hero-title">{slides[current].title}</h1>
        </span>

        <p className="hero-subtitle">
          {slides[current].description}
        </p>

        <a href="#contact" className="btn-premium">
          Discover More
        </a>
      </div>

      {/* 4. Progress Bar */}
      <div className="progress-container">
        <div className="slide-counter">
          {formatNumber(current + 1)} / {formatNumber(slides.length)}
        </div>

        <div className="progress-track">
          <div className="progress-bar" key={current}></div>
        </div>
      </div>

    </section>
  );
};

export default Hero;
